import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider, useStore } from "@/lib/store";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import BuyerHome from "@/pages/BuyerHome";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import OrdersPage from "@/pages/OrdersPage";
import OrderDetail from "@/pages/OrderDetail";
import VendorDashboard from "@/pages/VendorDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ToolsPage from "@/pages/ToolsPage";
import SavedListsPage from "@/pages/SavedListsPage";

function RequireRole({ roles, children }) {
  const { user } = useStore();
  if (user === null) return <p className="py-24 text-center text-sm text-slate-500" data-testid="route-loading">Loading…</p>;
  if (!user) return <Navigate to="/auth" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  // Process Google OAuth callback FIRST (synchronously) to avoid race conditions.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/buyer" element={<BuyerHome />} />
      <Route path="/product/:id" element={<ProductPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/tools" element={<ToolsPage />} />
      <Route path="/lists" element={<RequireRole roles={["buyer"]}><SavedListsPage /></RequireRole>} />
      <Route path="/orders" element={<RequireRole roles={["buyer", "admin"]}><OrdersPage /></RequireRole>} />
      <Route path="/orders/:id" element={<RequireRole roles={["buyer", "admin"]}><OrderDetail /></RequireRole>} />
      <Route path="/vendor" element={<RequireRole roles={["vendor"]}><VendorDashboard /></RequireRole>} />
      <Route path="/admin" element={<RequireRole roles={["admin"]}><AdminDashboard /></RequireRole>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col bg-slate-50">
          <Header />
          <div className="flex-1"><AppRoutes /></div>
          <Footer />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </StoreProvider>
  );
}

export default App;
